import axios from "axios";
import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PremiumRoomDetail = () => {
  const {t} = useTranslation();

  const form = useRef();
  const [formdata, setFormdata] = useState({
    fname: "",
    email: "",
    number: "",
    checkin: "",
    checkout: "",
    guest: "",
    rooms: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prev) => ({ ...prev, [name]: value }));
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_8furmhn",
        "template_szcx67x",
        form.current,
        "A8p5Pn26atBpFar7M"
      )
      .then(
        (result) => {
          toast.success("Booking Email Sent Successfully!");
          console.log(result.text);
          setFormdata({
            fname: "",
            email: "",
            number: "",
            checkin: "",
            checkout: "",
            guest: "",
            rooms: "",
          });
        },
        (error) => {
          toast.error("Failed to send booking email");
          console.log(error.text);
        }
      );
  };

  const settings = {
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div>
      <div className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-text">
                <h2>{t("premiumRoom")}</h2>
                <div className="bt-option">
                  <Link to="/rooms">{t("rooms")}</Link>
                  <span>{t("premiumRoom")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="room-details-section spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="room-details-item">
                <div className="room-img-slider">
                  <Slider {...settings}>
                  <div>
                      <img src="img/img4.jpg" alt="Room 1" />
                    </div>
                    <div>
                      <img src="img/img6.jpg" alt="Room 2" />
                    </div>
                    <div>
                      <img src="img/img1.jpg" alt="Room 3" />
                    </div>
                    <div>
                      <img src="img/img4.jpg" alt="Room 1" />
                    </div>
                    <div>
                      <img src="img/img16.jpg" alt="Room 2" />
                    </div>
                    <div>
                      <img src="img/img10.jpg" alt="Room 3" />
                    </div>
                    <div>
                      <img src="img/img12.jpg" alt="Room 2" />
                    </div>
                    <div>
                      <img src="img/img11.jpg" alt="Room 3" />
                    </div>
                  </Slider>
                </div>
                <div className="rd-text">
                  <div className="rd-title">
                    <h3>{t("mahoganyRoomtitle")}</h3>
                    <div className="rdt-right">
                      <div className="rating">
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star" />
                        <i className="fa-solid fa-star-half-stroke" />
                      </div>
                    </div>
                  </div>
                  <h2>
                  ₹2,678<span>/{t("price_per_night")}</span>
                  </h2>
                  <table>
                    <tbody>
                      <tr>
                        <td className="r-o">{t("size")}:</td>
                        <td>180 sq.ft</td>
                      </tr>
                      <tr>
                        <td className="r-o">{t("capacity")}:</td>
                        <td>{t("max_person")} 4</td>
                      </tr>
                      <tr>
                        <td className="r-o">{t("bed")}:</td>
                        <td>{t("king_beds")}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p className="f-para">
                  {t("premium_room_des")}
                  </p>
                  <p>
                    <strong>{t("oakroomSize")}:</strong>{t("room_size_details")}
                  </p>
                  <p>
                    <strong>{t("oakbedConfig")}:</strong> {t("bed_configuration_details")}
                  </p>
                  <p>
                    <strong>{t("amenities")}:</strong>
                    <ul>
                      <li>{t("amenity_1")}</li>
                      <li>
                      {t("amenity_2")}
                      </li>
                      <li>{t("amenity_3")}</li>
                      <li>
                      {t("amenity_4")}
                      </li>
                      <li>{t("amenity_5")}</li>
                      <li>{t("amenity_6")}</li>
                      <li>
                      {t("amenity_7")}
                      </li>
                      <li>
                      {t("amenity_8")}
                      </li>
                      <li>
                      {t("amenity_9")}
                      </li>
                      <li>
                      {t("amenity_10")}
                      </li>
                      <li>
                      {t("amenity_11")}
                      </li>
                      <li> {t("amenity_12")}</li>
                    </ul>
                  </p>
                  <p>
                    <strong>{t("additionalFeaturesTitle")}:</strong>
                    <ul>
                      <li>
                        {t("additional_feature_1")}
                      </li>
                      <li>
                      {t("additional_feature_2")}
                      </li>
                      <li>
                      {t("additional_feature_3")}
                      </li>
                      <li> {t("additional_feature_4")}</li>
                      <li>
                      {t("additional_feature_5")}
                      </li>
                    </ul>
                  </p>
                  <p>
                    <strong>{t("occupancy")}:</strong>{t("occupancy_details")}
                  </p>
                  <p>
                    <strong>{t("priceRange")}:</strong> {t("price_details")}
                  </p>
                </div>
              </div>
              <div className="rd-reviews">
                <h4>{t("reviews")}</h4>
                <div className="review-item">
                  <div className="ri-pic">
                    <img src="img/review1.jpg" alt="" />
                  </div>
                  <div className="ri-text">
                    <span>{t("review1date")}</span>
                    <div className="rating">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star-half-stroke" />
                    </div>
                    <h5>{t("review1name")}</h5>
                    <p>
                    {t("review1message")}
                    </p>
                  </div>
                </div>
                <div className="review-item">
                  <div className="ri-pic">
                    <img src="img/review1.jpg" alt="" />
                  </div>
                  <div className="ri-text">
                    <span>{t("review2date")}</span>
                    <div className="rating">
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star" />
                      <i className="fa-solid fa-star-half-stroke" />
                    </div>
                    <h5>{t("review2name")}</h5>
                    <p>
                    {t("review2message")}
                    </p>
                  </div>
                </div>
              </div>
              <div className="review-add">
                <h4>{t("add_review")}</h4>
                <form action="#" className="ra-form">
                  <div className="row">
                    <div className="col-lg-6">
                      <input type="text" placeholder={t("name")} required/>
                    </div>
                    <div className="col-lg-6">
                      <input type="text" placeholder={t("email_placeholder")} required/>
                    </div>
                    <div className="col-lg-12">
                      <div>
                        <h5>{t("your_rating")}:</h5>
                        <div className="rating">
                          <i className="fa-solid fa-star" />
                          <i className="fa-solid fa-star" />
                          <i className="fa-solid fa-star" />
                          <i className="fa-solid fa-star" />
                          <i className="fa-solid fa-star-half-stroke" />
                        </div>
                      </div>
                      <textarea placeholder={t("your_review")} defaultValue={""} />
                      <button type="submit">{t("submit_now")}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-lg-5">
              <div className="room-booking">
                <h3>{t("booking_your_hotel")}</h3>
                <form ref={form} onSubmit={sendEmail}>
                  <div className="check-date">
                    <label htmlFor="fname">{t("name")}</label>
                    <input
                      type="text"
                      id="fname"
                      name="fname"
                      placeholder={t("enter_name")}
                      value={formdata.fname}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="check-date">
                    <label htmlFor="email">{t("email_placeholder")}</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder={t("enter_email")}
                      value={formdata.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="check-date">
                    <label htmlFor="number">{t("number")}</label>
                    <input
                      type="number"
                      id="number"
                      name="number"
                      placeholder={t("enter_number")}
                      value={formdata.number}
                      onChange={handleChange}
                      required
                      min="1"
                    />
                  </div>
                  <div className="check-date">
                    <label htmlFor="checkin">{t("check_in")}:</label>
                    <input
                      type="date"
                      id="checkin"
                      name="checkin"
                      value={formdata.checkin}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="check-date">
                    <label htmlFor="checkout">{t("check_out")}:</label>
                    <input
                      type="date"
                      id="checkout"
                      name="checkout"
                      value={formdata.checkout}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="select-option">
                    <label htmlFor="guest">{t("guests")}:</label>
                    <select
                      id="guest"
                      name="guest"
                      className="nice-select"
                      value={formdata.guest}
                      onChange={handleChange}
                      required
                    >
                      <option value="">{t("select_guests")}</option>
                      <option value="2 Adults">{t("2_adults")}</option>
                      <option value="3 Adults">{t("3_adults")}</option>
                    </select>
                  </div>

                  <div className="select-option">
                    <label htmlFor="rooms">{t("room")}:</label>
                    <select
                      id="rooms"
                      name="rooms"
                      className="nice-select"
                      value={formdata.rooms}
                      onChange={handleChange}
                      required
                    >
                      <option value="">{t("select_rooms")}</option>
                      <option value="1 Room">{t("1_room")}</option>
                      <option value="2 Rooms">{t("2_rooms")}</option>
                    </select>
                  </div>
                  <button type="submit">{t("book_now")}</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ToastContainer />
    </div>
  );
};

export default PremiumRoomDetail;
